'use client';

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@manaboo/ui/dialog';
import {ButtonsAuth} from '@/components/buttons-auth';
import {useAuthDialog} from '@/hooks/use-dialog-auth';

interface DialogAuthProps {
	isTestEnv?: boolean;
}

export function DialogAuth({isTestEnv = false}: DialogAuthProps) {
	const {isOpen, setDialog} = useAuthDialog();

	return (
		<Dialog
			open={isOpen}
			onOpenChange={setDialog}
		>
			<DialogContent
				className="sm:max-w-[425px]"
				data-testid="dialog-auth"
			>
				<DialogHeader>
					<DialogTitle>Załóż konto</DialogTitle>
					<DialogDescription>
						Nie czekaj, dołącz do graczy, którzy już zarabiają i
						znajdują najlepsze gry na na Roblox!
					</DialogDescription>
				</DialogHeader>

				<ButtonsAuth isTestEnv={isTestEnv} />
			</DialogContent>
		</Dialog>
	);
}
